export default function NotFound() {
  return (
    <div>
      <h1>404 Няма такава страница</h1>
    </div>
  );
}
